import { z } from "zod";
export const TOMBSTONE_KEY_VERSION = "better-auth-hkdf-sha256-v1";
export const TOMBSTONE_CANONICALIZATION_VERSION = "tombstone-email-canonicalization-v1";
const tombstoneEmailSchema = z.email().max(320);
const asciiEdgeWhitespace = /^[\t\n\v\f\r ]+|[\t\n\v\f\r ]+$/g;
export function canonicalizeTombstoneEmail(email) {
    const canonical = email
        .replace(asciiEdgeWhitespace, "")
        .replace(/[A-Z]/g, (character) => character.toLowerCase());
    return tombstoneEmailSchema.safeParse(canonical).success ? canonical : undefined;
}
export function isSupportedTombstoneVersion(keyVersion, canonicalizationVersion) {
    return (keyVersion === TOMBSTONE_KEY_VERSION &&
        canonicalizationVersion === TOMBSTONE_CANONICALIZATION_VERSION);
}
//# sourceMappingURL=tombstones.js.map